import ReactGA4 from 'react-ga4';

const InitAnalytics = (): void => {
  ReactGA4.initialize('G-H8V4P59WXV')
}

const TrackGameWon = (won: boolean, guessCount: number) => {
  ReactGA4.event({
    category: `Game ${won ? 'Win' : 'Loss'}`,
    action: `${won ? 'Win' : 'Loss'}`,
    value: guessCount,
  })
}

export default InitAnalytics;
export { InitAnalytics, TrackGameWon }